var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    fill: "none",
    color: "#12344D",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#insert_1_svg__clip0)",
    fill: "#12344D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.378 11.111V4.267c0-.356.266-.534.622-.534.355 0 .622.178.622.534v6.844a.622.622 0 1 1-1.244 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.378 7.111H8.622a.622.622 0 0 0 0 1.245h6.756a.622.622 0 0 0 0-1.245zM5.6 7.111H.622a.622.622 0 0 0 0 1.245H5.6a.622.622 0 0 0 0-1.245zM9.156 3.556H.622a.622.622 0 0 0 0 1.244h8.534a.622.622 0 0 0 0-1.244zM11.822 0H.622a.622.622 0 1 0 0 1.244h11.2a.622.622 0 1 0 0-1.244z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "insert_1_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v11.733H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomSelect);
export default __webpack_public_path__ + "static/media/custom-select.af8d721cda0060ce48332325b498039e.svg";
export { ForwardRef as ReactComponent };